export default __webpack_public_path__ + "static/media/8.39d46a61.jpeg";